import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ColorTextBackgroundIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M21 19a1 1 0 011 1v2a1 1 0 01-1 1H3a1 1 0 01-1-1v-2a1 1 0 011-1h18zM11.668 1.561l.087.078 7.071 7.071a1 1 0 01.083 1.32l-.083.094-7.07 7.071a3 3 0 01-4.1.135l-.143-.135-4.243-4.242a3 3 0 01-.135-4.099l.135-.144L6.45 5.528 4.977 4.053a1 1 0 011.327-1.492l.087.078 1.475 1.474L10.34 1.64a1 1 0 011.327-.078zM19 11.5c1.333 1.84 2 3.145 2 3.913 0 1.153-.895 2.087-2 2.087s-2-.934-2-2.087c0-.768.667-2.073 2-3.913zm-7.952-7.74L9.28 5.527l.5.5a2.501 2.501 0 012.562.448l.12.113a2.5 2.5 0 11-4.096.855l-.5-.502-3.182 3.182a1 1 0 00-.143 1.234l.065.093.078.088 4.243 4.242a1 1 0 001.32.083l.094-.083 6.364-6.365-5.657-5.657zm-.707 4.243a.5.5 0 10.707.707.5.5 0 00-.707-.707z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
ColorTextBackgroundIcon.isCarinaIcon = true;
export default ColorTextBackgroundIcon;
